import { AppRoutes } from '@constants/app-routes'
import Agile from '@public/images/animated-icons/agile.svg'
import CodeQuality from '@public/images/animated-icons/code-quality.svg'
import LargeTriangle from '@public/images/animated-icons/large-triangle.svg'
import TriangleSmall from '@public/images/animated-icons/triangle-small.svg'
import Triangle from '@public/images/animated-icons/triangle.svg'
import HexagonDark from '@public/images/gradientGrayPolygon.svg'
import { Link } from '@ui/links/Link'

import {
  BottomCatchTriangle,
  BottomCatchTriangleOrange,
  LeftSideTriangle,
  LeftSideTriangleOrange,
  TopTriangle,
  TriangleSmallOrange,
  LargeTriangleOrange,
} from './styles'

const imageSize = {
  imageWidth: 60,
  imageHeight: 60,
}

export const config = {
  title: 'Cloud DevOps with Modsen',
  subtitle: (
    <>
      <Link href={AppRoutes.aboutUs}>Our team</Link> is targeted at creating an
      impeccable environment for productive cooperation with our partners.
      Premium-quality software, 100% KPI implementation, and deadline compliance
      are guaranteed.
    </>
  ),
  heightBlock: 330,
  items: [
    {
      id: 1,
      title: 'Agile\nmethodology',
      text: `We employ the best Scrum and Kanban practices for agile Cloud development. The transparency of teams’ performance allows our partners to closely monitor every stage of the software development process.`,
      icon: <Agile />,
      imageClassName: 'agile',
      padding: 55,
      additionalImages: [
        {
          id: 'Triangle',
          imageComponent: <Triangle />,
          imageComponentHover: <TopTriangle />,
          options: {
            top: 0,
            right: 0,
          },
        },
      ],
      ...imageSize,
    },
    {
      id: 2,
      title: 'Relevant\nexperience',
      text: `Modsen engineers enjoy extensive experience in a variety of business domains. Your product will be built by high-end relevant professionals expertised in the development of projects similar to yours. We’ll get down to work within a week and seamlessly integrate into your environment.`,
      padding: 55,
      imagePath: 'seamless-integration',
      additionalImages: [
        {
          id: 'Triangle',
          imageComponent: <BottomCatchTriangle />,
          imageComponentHover: <BottomCatchTriangleOrange />,
          options: {
            bottom: -8,
            right: 2,
          },
        },
        {
          id: 'Hexagon',
          imageComponent: <HexagonDark />,
          imageComponentHover: <HexagonDark />,
          options: {
            top: -35,
            right: -70,
          },
        },
      ],
      ...imageSize,
    },
    {
      id: 3,
      title: 'Resource optimization',
      text: `Our team employs cutting-edge effective Cloud solutions that allow us to justify the resources spent on the development of your app. Cut costs and save precious time cooperating with Modsen.`,
      imagePath: 'developers-competence',
      padding: 55,
      additionalImages: [
        {
          id: 'Triangle',
          imageComponent: <TriangleSmall />,
          imageComponentHover: <TriangleSmallOrange />,
          options: {
            top: 0,
            right: 0,
          },
        },
      ],
      ...imageSize,
    },
    {
      id: 4,
      title: 'Clean code',
      text: `Your product will be developed on the basis of clear and simple code which facilitates the app’s agility allowing for easy scaling and adjustment.`,
      icon: <CodeQuality />,
      imageClassName: 'code-quality',
      padding: 55,
      additionalImages: [
        {
          id: 'Triangle',
          imageComponent: <LargeTriangle />,
          imageComponentHover: <LargeTriangleOrange />,
          options: {
            bottom: -6,
            left: 0,
          },
        },
      ],
      ...imageSize,
    },
    {
      id: 5,
      title: 'Data safety',
      text: `Safety protocols are within our prime focus. We are targeted at maximum protection of your user data and eliminate any cybersecurity risks.`,
      imagePath: 'security',
      padding: 55,
      additionalImages: [
        {
          id: 'Triangle',
          imageComponent: <LeftSideTriangle />,
          imageComponentHover: <LeftSideTriangleOrange />,
          options: {
            bottom: 0,
            left: -73,
          },
        },
      ],
      ...imageSize,
    },
    {
      id: 6,
      title: 'Convenient monitoring',
      text: `Experience hands-on control over the development process in real-time. Choose any of the convenient ways of monitoring and benefit from ultimate app-building transparency.`,
      imagePath: 'performance-monitoring',
      padding: 55,
      additionalImages: [
        {
          id: 'Triangle',
          imageComponent: <BottomCatchTriangle />,
          imageComponentHover: <BottomCatchTriangleOrange />,
          options: {
            bottom: -8,
            right: 2,
          },
        },
        {
          id: 'Hexagon',
          imageComponent: <HexagonDark />,
          imageComponentHover: <HexagonDark />,
          options: {
            top: -35,
            right: -70,
          },
        },
      ],
      imageWidth: 70,
      imageHeight: 70,
    },
  ],
}
